









































































import { ConfirmButton, Toggle } from '@/app/components';
import { computed, defineComponent, PropType, ref } from '@vue/composition-api';
import { Workflow, WorkflowTrigger } from '../../types';
import { XCircleIcon, ExclamationCircleIcon, ExclamationIcon } from '@vue-hero-icons/solid';
import { TriggerSummary } from '.';
import { v4 as uuidv4 } from 'uuid';
export default defineComponent({
    name: 'Trigger',
    components: {
        Toggle,
        ConfirmButton,
        XCircleIcon,
        ExclamationCircleIcon,
        ExclamationIcon,
        TriggerSummary,
    },
    props: {
        workflow: {
            type: Object as PropType<Workflow>,
            required: true,
        },
        trigger: {
            type: Object as PropType<WorkflowTrigger>,
            required: true,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        selected: {
            type: Object as PropType<WorkflowTrigger>,
        },
        disabled: {
            type: Boolean,
            default: true,
        },
        disabledMessage: {
            type: String,
        },
    },
    setup(props) {
        const hoveredItem = ref(null);

        const isSelected = computed(() => props.selected?.id === props.trigger.id);

        const setToggleBgColor = () => (hoveredItem.value ? 'bg-neutral-200' : 'bg-neutral-100');
        const setToggleAdditionalInputClass = () => (!props.trigger.isEnabled ? 'bg-neutral-300' : '');

        const hasAccessToConditions = computed(() =>
            props.trigger.conditions.every((condition: any) => condition.hasAccess),
        );

        const hasInvalidInputAsset = computed(() =>
            props.trigger.conditions.some((condition: any) => condition.hasInvalidInputAsset),
        );

        return {
            hoveredItem,
            isSelected,
            setToggleBgColor,
            setToggleAdditionalInputClass,
            hasAccessToConditions,
            hasInvalidInputAsset,
            uuidv4,
        };
    },
});
